module.exports = __webpack_public_path__ + "static/media/antiquePlates.73a5f342.jpg";